import React from "react";

import { Button } from "aible";
import { isEnabled } from "utils/featureFlags";

import { ReviewDatasetColumn, ReviewDatasetHeader } from "components/CreateWizard/Academic/AcademicReviewDataset";

import DatasetItem from "containers/View/Item/DatasetItem";

import styles from "./style.module.css";

export default class SelectDataset extends React.PureComponent {
  render() {
    const { id, selectedDataset, datasetView, updateSelection, hideHeader } = this.props;

    if (selectedDataset) {
      return (
        <ReviewDatasetColumn noGrow>
          {!hideHeader && (
            <ReviewDatasetHeader
              error={!selectedDataset}
              header={"Selected Dataset"}
              noGrow
              className={styles.leftAlign}
            />
          )}
          <DatasetItem isTile id={selectedDataset.id} noHover noClick />
          {updateSelection && !isFinite(id) ? (
            <div className={styles.changeDatasetWrapper}>
              <Button onClick={() => updateSelection(undefined)}>{"Change"}</Button>
            </div>
          ) : (
            ""
          )}
        </ReviewDatasetColumn>
      );
    } else {
      return datasetView ? (
        <div className={styles.datasetHolder}>
          <div
            className={styles.datasetList}
            style={
              selectedDataset === undefined || blueprintId !== undefined
                ? {}
                : {
                    background: "rgb(146, 207, 72, 0.15)",
                    alignItems: "center",
                    border: "1px solid rgb(146, 207, 72, 0.55)"
                  }
            }
          >
            {datasetView}
          </div>
        </div>
      ) : (
        <div>{"No dataset selected"}</div>
      );
    }
  }
}
